var map = {
	"./business-card.png": 556,
	"./docs.png": 224,
	"./first_place.png": 388,
	"./hbz_logo.png": 718,
	"./medal.png": 763,
	"./profile.png": 132,
	"./sheets.png": 859,
	"./wasp.png": 974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;